import axios from 'axios';
import { v2 } from '@lendica/api';
import { useCompanyApi } from '@lendica/hooks';
import { useMemo } from 'react';
import {
    Deal,
    DataConnection,
    Approval,
    RateCurve,
    Invoice,
    Offer,
    Customer,
} from '@lendica/utils';

export const awsURL = 'https://micro-awsmanager.herokuapp.com/s3';
export const presignedUrl = `${awsURL}/signed-url`;
export const bucket_name = 'lendica-pod';

// export const getCompanyDetails = async (): Promise<any> => {
//     const response = await axios.get('/company/details');
//     return response.data;
// };

// export const getDataConnections = async (): Promise<any> => {
//     return (await axios.get('/company/connections')).data;
// };

// export const getCompany = async (): Promise<any> => {
//     const response = await axios.get('/company/summary');
//     return response.data;
// };

// export const getInvoicesList = async () => {
//     const response = await axios.get('/company/invoices');
//     return response.data;
// };

// export const getFundnowApproval = async () => {
//     const approvalsList = (await axios.get('/company/approvals')).data;
//     return approvalsList.find(
//         (approval: any) => approval.active === true && approval.product_name === 'fundnow'
//     );
// };

// export const getFundnowFullApproval = async () => {
//     const approvalId = (await getFundnowApproval()).id;
//     return await getApprovalDetails(approvalId);
// };

// export const getDealsList = async () => {
//     const dealsList = (await axios.get(`/company/deals`)).data;
//     return dealsList.filter((deal: any) => deal.product_name === 'fundnow');
// };

// export const archiveInvoice = async (id: string) => {
//     const response = await axios.get(`/company/invoices/archive?id=${id}`);
//     return response.data;
// };

// // FundNow

// export const getInvoice = async (invoiceId: string) => {
//     const response = await axios.get(`/company/invoices?id=${invoiceId}`);
//     return response.data;
// };

// export const getInvoices = async () => {
//     const response = await axios.get('/company/invoices');
//     return response.data;
// };

// export const getInvoiceDetails = async (invoiceId: string) => {
//     const response = await axios.get(`/fundnow/invoice/confirm?invoice_id=${invoiceId}`);
//     return response.data;
// };

export const getOffers = async (invoiceId: string) => {
    const response = await axios.get(`/fundnow/invoice/offer?invoice_id=${invoiceId}`);
    return response.data;
};

// export const confirmInvoiceDetails = async (data: any) => {
//     const response = await axios.post(
//         `/fundnow/invoice/confirm?invoice_id=${data!.invoice!.id}`,
//         data
//     );
//     return response.data;
// };

// export const getCustomersList = async () => {
//     const response = await axios.get('/company/customers');
//     return response.data;
// };

// export const postCustomer = async (data: any) => {
//     return (await axios.post('/company/customers', data)).data;
// };

// export const postCustomerToInvoice = async (data: any, invoiceId: string) => {
//     return (
//         await axios.post('/company/customers', {
//             invoice_id: invoiceId,
//             customer: data,
//         })
//     ).data;
// };

// export const createFundnowDeal = async (invoiceId: string) => {
//     return (
//         await axios.post('/fundnow/deal/init', {
//             invoice_id: invoiceId,
//         })
//     ).data;
// };

export const activateFundnow = async () => {
    const res = await axios.get('/fundnow/activate');
};

// export const getDealDetails = async (id: string) => {
//     const response = await axios.get(`/company/deals?id=${id}`);
//     return response.data;
// };

// export const processInvoice = async (objectKey: string) => {
//     const response = await axios.post('/fundnow/invoice/process', {
//         object_name: objectKey,
//         object_folder: 'lendica-pod',
//     });
//     return response.data;
// };

export type DeepPartial<T> = T extends object
    ? {
          [P in keyof T]?: DeepPartial<T[P]>;
      }
    : T;

export const useFundnowApi = () => {
    const api = useCompanyApi();
    return useMemo(
        () => ({
            getCompanyDetail: () => api.get('/companies/detail'),
            // TODO: handle v2 pagination in UI
            getDataConnections: async (page = 1, pageSize = 50) => {
                const data = await api.get<v2.PaginatedResponse<DataConnection>>(
                    '/connections/list',
                    {
                        params: { page, page_size: pageSize },
                    }
                );
                return data.results;
            },
            getFundnowApproval: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Approval>>('/approvals/list', {
                    params: { product_name: 'fundnow', active: true, page, page_size: pageSize },
                }),
            getApprovalSummary: async (page = 1, pageSize = 20) => {
                const approvalList = await api.get<v2.PaginatedResponse<Approval>>(
                    '/approvals/list',
                    {
                        params: {
                            product_name: 'fundnow',
                            active: true,
                            page,
                            page_size: pageSize,
                        },
                    }
                );
                const rateCurves = await api.get<RateCurve[]>('/ratecurve_backbones/detail');
                return approvalList.results.map(approval => {
                    const rcs = rateCurves.filter(rateCurve => rateCurve.approval === approval.id);
                    return { ...approval, rateCurve: rcs.sort((a, b) => a.day - b.day) };
                });
            },
            getDealsList: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Deal>>('/deals/list', {
                    params: { page, page_size: pageSize, product_name: 'fundnow' },
                }),
            getDealByID: (dealId: string) =>
                api.get('/deals/detail', { params: { deal_id: dealId } }),
            getInvoicesList: (page = 1, pageSize = 20) =>
                api.get<v2.PaginatedResponse<Invoice>>('/invoices/list', {
                    params: { page, page_size: pageSize },
                }),
            getInvoiceByID: (invoiceId: string) =>
                api.get('/invoices/detail', { params: { invoice_id: invoiceId } }),
            postCustomerToInvoice: (customer: DeepPartial<Customer>, invoiceId: string) =>
                api.post('/customers', { invoice_id: invoiceId, customer }, { unwrap: false }),
            getInvoiceDetails: (invoiceId: string) =>
                api.get(`/fundnow/invoice/confirm?invoice_id=${invoiceId}`),
            confirmInvoiceDetails: (invoiceId: string, data: any) =>
                api.post<{ invoice_id: string }>(
                    `/fundnow/invoice/confirm?invoice_id=${invoiceId}`,
                    data
                ),
            getOffer: (invoiceId: string) =>
                api.get<{ invoice: Invoice; offer: Offer }>(
                    `/fundnow/invoice/offer?invoice_id=${invoiceId}`
                ),
            getCustomersList: (page = 1, pageSize = 50) =>
                api.get<v2.PaginatedResponse<Customer>>('/customers/list', {
                    params: { page, page_size: pageSize },
                }),
            getCustomerByID: (customerId: string) =>
                api.get('/customers/detail', { params: { customer_id: customerId } }),
            createCustomer: (customer: DeepPartial<Customer>) =>
                api.post('/customers/create', customer),
            updateCustomer: (customer: DeepPartial<Customer>) =>
                api.post('/customers/update', { customer_id: customer.id, ...customer }),
            activateFundnow: () => api.get('/fundnow/activate'),
            archiveInvoice: (invoiceId: string) => api.get(`/invoices/archive?id=${invoiceId}`),
            processInvoice: (objectKey: string) =>
                api.post<{ invoice: Invoice }>('/fundnow/invoice/process', {
                    object_name: objectKey,
                    object_folder: 'lendica-pod',
                }),
            initializeDeal: async (invoiceId: string) => {
                const data = await api.post<{ deal: Deal }>('/fundnow/deal/init', {
                    invoice_id: invoiceId,
                });
                return data.deal.id;
            },
        }),
        [api]
    );
};
